import React, { useState } from "react";
import Helmet from "react-helmet";
import Layout from "../../Layout/layout";
import appStoreBadge from "../../Assets/app-store-download-badge.png";
import visiontrakAppQr from "../../Assets/visiontrak-app-qr.png";
import "../../styles/apps/apps.scss";

const APP_STORE_URL = "https://apps.apple.com/au/app/visiontrak/id6749840203";

const Apps = () => {
  const [activeTab, setActiveTab] = useState("iphone");

  return (
    <Layout>
      <Helmet>
        <title>Apps | VisionTrak</title>
      </Helmet>
      <main className="apps-page">
        <section className="apps-shell" aria-labelledby="apps-heading">
          <header className="apps-header">
            <span className="apps-eyebrow">VisionTrak mobile</span>
            <h1 id="apps-heading">Access on the go</h1>
            <p>Stay connected to your fleet wherever the day takes you.</p>
          </header>

          <div className="apps-tabs" role="tablist" aria-label="Mobile app platform">
            <button
              aria-controls="iphone-panel"
              aria-selected={activeTab === "iphone"}
              className={activeTab === "iphone" ? "active" : ""}
              id="iphone-tab"
              onClick={() => setActiveTab("iphone")}
              role="tab"
              type="button"
            >
              iPhone
            </button>
            <button
              aria-controls="android-panel"
              aria-selected={activeTab === "android"}
              className={activeTab === "android" ? "active" : ""}
              id="android-tab"
              onClick={() => setActiveTab("android")}
              role="tab"
              type="button"
            >
              Android
            </button>
          </div>

          {activeTab === "iphone" ? (
            <section aria-labelledby="iphone-tab" className="apps-panel" id="iphone-panel" role="tabpanel">
              <div className="apps-copy">
                <span className="apps-platform-label">Available now for iPhone</span>
                <h2>Manage your fleet from anywhere</h2>
                <p>We also offer an <strong>iPhone app</strong>, so you can manage your fleet wherever you are.</p>
                <p>Use your existing VisionTrak login credentials to access your account through the app.</p>
                <p>Download the app today and start managing your fleet on the go.</p>
                <a className="apps-store-link" href={APP_STORE_URL} rel="noopener noreferrer" target="_blank">
                  <img alt="Download VisionTrak on the App Store" src={appStoreBadge} />
                </a>
              </div>
              <aside className="apps-qr-card">
                <span>Scan with your phone camera</span>
                <a href={APP_STORE_URL} rel="noopener noreferrer" target="_blank">
                  <img alt="QR code to download the VisionTrak app" src={visiontrakAppQr} />
                </a>
                <strong>Download VisionTrak App</strong>
              </aside>
            </section>
          ) : (
            <section aria-labelledby="android-tab" className="apps-panel apps-panel-android" id="android-panel" role="tabpanel">
              <div className="apps-copy">
                <span className="apps-platform-label apps-platform-testing">Testing access</span>
                <h2>VisionTrak for Android</h2>
                <p>Our Android app is currently in its testing phase and is available to registered testers.</p>
                <p>To request access, contact VisionTrak using the email address linked to your Google Play Store account. We will register you as a tester and provide access to the app.</p>
                <a className="apps-contact-link" href="mailto:support@visiontrak.com.au?subject=VisionTrak%20Android%20app%20testing%20access">
                  Request testing access
                </a>
                <small>Please include your Google Play Store email address in your request.</small>
              </div>
              <div className="apps-android-mark" aria-hidden="true">
                <span className="fa fa-android" />
              </div>
            </section>
          )}
        </section>
      </main>
    </Layout>
  );
};

export default Apps;
